export const polarRandom = (scale = 1, offset = 0) => {
    const random = (0.5 - Math.random()) * 2 * scale;
    return Math.sign(random) *  Math.abs(offset + random);
};

export const minmax = (val = 0, min = 0, max = 1) => Math.min(Math.max(val, min), max);
